/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


window.trellis = window.trellis || {};
window.trellis.update_variantHoverThumb = function(target) {
  var ProductItem = target.closest('.ProductItem');
  var originalImageElement = ProductItem.querySelector('.ProductItem__Image.ProductItem__Image--alternate');

  // update the secondary image src
  if (target.hasAttribute('data-variant-image-url') && target.getAttribute('data-variant-image-id') !== originalImageElement.getAttribute('data-variant-image-id')) {
    var newImageElement = document.createElement('img');
    newImageElement.className = 'ProductItem__Image ProductItem__Image--alternate Image--fadeIn Image--lazyLoad';
    newImageElement.setAttribute('data-image-id', target.getAttribute('data-variant-image-id'));
    newImageElement.setAttribute('data-src', target.getAttribute('data-variant-image-url'));
    newImageElement.setAttribute('data-widths', target.getAttribute('data-variant-image-widths'));
    newImageElement.setAttribute('data-sizes', 'auto'); // Replace the original node

    if (window.theme.productImageSize === 'natural') {
      originalImageElement.parentNode.style.paddingBottom = "".concat(100.0 / target.getAttribute('data-variant-image-aspect-ratio'), "%");
    }

    originalImageElement.parentNode.style.setProperty('--aspect-ratio', target.getAttribute('data-variant-image-aspect-ratio'));
    originalImageElement.parentNode.replaceChild(newImageElement, originalImageElement);
  }
}

function docReady(fn) {
  if (document.readyState === "complete" || document.readyState === "interactive") {
    setTimeout(fn, 1);
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

const optionElement = document.getElementById('optionQuantities');
const optionQuantities = optionElement ? JSON.parse(optionElement.innerText) : {};

const optionAvailabilitiesElement = document.getElementById('optionAvailabilities');
const optionAvailabilities = optionAvailabilitiesElement ? JSON.parse(optionAvailabilitiesElement.innerText) : {};

function checkSizeAvailability() {

  const selectedColorEl = document.querySelector('.Product .ColorSwatch__Radio:checked');
  const selectedColor = selectedColorEl ? selectedColorEl.value : '';
  const sizeOptions = document.querySelectorAll('.SizeSwatch__Radio');

  window.availabilities = optionAvailabilities;

  sizeOptions.forEach((sizeOption) => {
    const sizeOptionParent = sizeOption.parentElement;
    const sizeValue = sizeOption.value;
    let variantLabel;

    if (selectedColor) {
      variantLabel = `${selectedColor}_${sizeValue}`;
    } else {
      variantLabel = sizeValue;
    }

    const quantity = optionQuantities[variantLabel];
    const available = optionAvailabilities[variantLabel];
      if (available) {
        sizeOptionParent.classList.remove('HorizontalList__Item--sold-out');
      } else {
        sizeOptionParent.classList.add('HorizontalList__Item--sold-out');
      }
  });
}

function preorderMessage() {
  const variantId = $(".Product").data("variant");
  if (window?._supertheme?._preorders && variantId) {
    const isPreorder = window._supertheme._preorders[variantId] && window._supertheme._preorders[variantId].status;
    const preorderMessage = window._supertheme._preorders[variantId] && window._supertheme._preorders[variantId].message;
    if (isPreorder) {
      if (preorderMessage){
        $('#preorder-shipping').val(preorderMessage);
      }
    }
  }
}



document.addEventListener('variant:changed', function(event) {
  checkSizeAvailability();
});

docReady(function() {
  checkSizeAvailability();
  preorderMessage();
});

document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant;
  onVariantChange(event)
});

//===========================================================================
// Makes updates for a variant change
//===========================================================================

function onVariantChange(e) {
  const $target = $(e.currentTarget);
  const variant = e.detail.variant;

  console.log('VARIANT CHANGE');
  console.log(variant);

  if (variant && variant.id) {
    updatePageForPreorder($target, variant.id)
  }
}

//===========================================================================
// Updates Page for Preorder
//===========================================================================

function updatePageForPreorder($parent, variantId) {

  if (window?._supertheme?._preorders) {
    const $template = $('.product-template');
    const $form = $template.find('.js-product-form');
    const $property = $template.find('.js-preorder-property');
    const $property2 = $template.find('.js-preorder-property-2');
    const $message = $template.find('.js-preorder-message');
    const isPreorder = window._supertheme._preorders[variantId] && window._supertheme._preorders[variantId].status;
    const preorderMessage = window._supertheme._preorders[variantId] && window._supertheme._preorders[variantId].message;
    const propertyTemplate = `<input type='hidden' class='js-preorder-property' name='properties[Preorder]' value='true' />`;
    const propertyTemplate2 = `<input type='hidden' class='js-preorder-property-2' name='properties[Note]' id='preorder-shipping' value='' />`;

    $property.remove();
    $property2.remove();

    if (isPreorder && !$template.hasClass('product-gift-card')) {
      if (preorderMessage) {
        $message.text(preorderMessage);
      } else {
        $message.text('');
      }

      $template.addClass('preorder');
      // $form.append(propertyTemplate);
      $form.append(propertyTemplate2);
      $('#preorder-shipping').val(preorderMessage);

    } else {
      $template.removeClass('preorder');
      $message.text('');
    }
  }
}


// PDP carousel thumbnail buttons
// document.getElementById('js-Product__SlideshowNavTopButton').onclick = function() {
//   scrollCarouselNav(document.getElementById('js-Product__SlideshowNavScroller'), 'top', 25, 100, 10);
// };

// document.getElementById('js-Product__SlideshowNavBottomButton').onclick = function() {
//   scrollCarouselNav(document.getElementById('js-Product__SlideshowNavScroller'), 'bottom', 25, 100, 10);
// };

// function scrollCarouselNav(element, direction, speed, distance, step) {
//   scrollAmount = 0;
//   let slideTimer = setInterval(function() {
//     direction == 'top' ? element.scrollTop -= step : element.scrollTop += step;
//     scrollAmount += step;
//     if (scrollAmount >= distance) {
//       window.clearInterval(slideTimer);
//     }
//   }, speed);
// }

var slideshowBtnTop = document.getElementById('js-Product__SlideshowNavTopButton');

if (slideshowBtnTop) {
  slideshowBtnTop.onclick = function() {
    scrollCarouselNav(document.getElementById('js-Product__SlideshowNavScroller'), 'up', 25, 100, 10);
  };
}

var slideshowBtnBottom = document.getElementById('js-Product__SlideshowNavBottomButton');

if (slideshowBtnBottom) {
  slideshowBtnBottom.onclick = function() {
    scrollCarouselNav(document.getElementById('js-Product__SlideshowNavScroller'), 'down', 25, 100, 10);
  };
}

function scrollCarouselNav(element, direction, speed, distance, step) {
  const slideHeight = element.querySelector('.Product__SlideshowNavImage').clientHeight;
  const maxScroll = element.scrollHeight - element.clientHeight;

  let scrollAmount = 0;
  let slideTimer = setInterval(function() {
    if (direction === 'up') {
      element.scrollTop -= step;
      if (element.scrollTop <= 0) {
        element.scrollTop = maxScroll;
      }
    } else {
      element.scrollTop += step;
      if (element.scrollTop >= maxScroll) {
        element.scrollTop = 0;
      }
    }
    scrollAmount += step;

    if (scrollAmount >= distance) {
      clearInterval(slideTimer);
    }
  }, speed);
}




//===========================================================================
// Announcement Bar Carousel
//===========================================================================

function runAnnouncementSlideshow($section) {
  if ($section[0]) {
    const $slides = $section.find('[data-type="announcement-slide"]');
    const timing = $section.data('timing') || 5;
    const timingMs = Number(timing) * 1000;

    setTimeout(() => {
      if ($slides.length > 1) {
        let nextSlide = 0;

        for (let i = 0; i < $slides.length; i++) {
          const $slide = $($slides[i]);

          if ($slide.hasClass('active') && i < ($slides.length - 1)) {
            nextSlide = i + 1;
            break;
          }
        }

        if ($slides[nextSlide]) {
          $slides.removeClass('active');
          $slides[nextSlide].classList.add('active');
        }
      }

      runAnnouncementSlideshow($section);
    }, timingMs);
  }
}

//===========================================================================
// When a Klaviyo newsletter form is submitted
//===========================================================================

function onKlaviyoFormSubmit(e) {
  e.preventDefault();
  console.log("something's happening")

  const $form = $(e.currentTarget);
  const formData = $form.serializeArray();
  const data = {};

  formData.forEach((obj) => {
    if (obj.name && obj.value) {
      if (obj.name === 'g') {
        data.list_id = obj.value;
      } else if (obj.name === '$source') {
        data.custom_source = obj.value;
      } else if (obj.name === 'email') {
        data.email = obj.value;
      } else if (obj.name === '$phone_number') {
        data.phone_number = `+1${obj.value}`;
      }
    }
  });

  data.properties = {};

  console.log('SUBMIT');
  console.log(data);
  subscribeToKlaviyoList($form, data);
}

//===========================================================================
// Subscribes user to a Klaviyo list
//===========================================================================

function subscribeToKlaviyoList($form, data) {
  const url = 'https://a.klaviyo.com/client/subscriptions/?company_id=KWrjxg';
  const options = {
    method: 'POST',
    headers: {revision: '2023-02-22', 'content-type': 'application/json'},
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: data
      }
    })
  };

  fetch(url, options)
    .then((res) => {
      console.log('SIGNUP SUCCESS');
      onKlaviyoSubmit($form);
    }).catch((err) => {
      console.error('error:' + err)
    });
}

//===========================================================================
// When a klaviyo form is submitted
//===========================================================================

function onKlaviyoSubmit($form) {
  $form.find('.js-newsletter-form').hide();
  $form.find('.js-newsletter-form-success').show();
}


$(document).ready(function() {
  const $announcementBars = $('[data-action="announcement-carousel"]');

  $announcementBars.each((i, section) => {
    runAnnouncementSlideshow($(section));
  });

  $(document).on('submit', '.js-klaviyo-form', onKlaviyoFormSubmit);
});


$(document).ready(function() {
  class SectionSwitcher {
    //===========================================================================
    // Constructor
    //===========================================================================
  
    constructor() {
      console.log('SWITCH');
      this.setupEventListeners();
    }
  
    //===========================================================================
    // Switches the section based on link clicks
    //===========================================================================
  
    switchSectionOnLinkClick(e) {
      const $target = $(e.currentTarget);
  
      if ($target.is('a')) {
        e.preventDefault();
      }
  
      this.switchSection($target);
    }
  
    //===========================================================================
    // Switches the section
    //===========================================================================
  
    switchSection($target) {
      const $parent     = $target.closest('.js-switch-parent');
      const $links      = $parent.find('.js-switch-link').not($parent.find('.js-switch-parent .js-switch-link'));
      const $sections   = $parent.find('.js-switch-section').not($parent.find('.js-switch-parent .js-switch-section'));
      const sectionType = $target.data('type');
      const hiddenClass = 'hidden';
  
      $links.removeClass('active');
      $links.filter(`[data-type="${ sectionType }"]`).addClass('active');
  
      $sections.each((i, section) => {
        let $section = $(section);
  
        if ($section.data('type') === sectionType) {
          $section.removeClass(hiddenClass);
        } else {
          $section.addClass(hiddenClass);
        }
      });
    }
  
    //===========================================================================
    // Sets up event listeners
    //===========================================================================
  
    setupEventListeners() {
      $(document).on('click', '.js-switch-link', this.switchSectionOnLinkClick.bind(this));
    }
  }

  new SectionSwitcher();
});
